const initialState = {
  coupons: null,
  coupon: null,
  builderList: null,
  categoryList: null, // ✅ added for category API response
  loading: false,
  error: null,
};

export const couponReducer = (state = initialState, action) => {
  switch (action.type) {
    // ================================
    // Coupon List Actions
    // ================================
    case "GET_COUPON_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        coupons: null,
        error: null,
      };
    case "GET_COUPON_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        coupons: action.payload,
        error: null,
      };
    case "GET_COUPON_LIST_FAILED":
      return {
        ...state,
        loading: false,
        coupons: null,
        error: action.payload,
      };

    // ================================
    // Add Coupon Actions
    // ================================
    case "ADD_COUPON_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "ADD_COUPON_SUCCESS":
      return {
        ...state,
        loading: false,
        coupons: action.payload,
        error: null,
      };
    case "ADD_COUPON_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ================================
    // View Coupon Actions
    // ================================
    case "VIEW_COUPON_REQUEST":
      return {
        ...state,
        loading: true,
        coupon: null,
        error: null,
      };
    case "VIEW_COUPON_SUCCESS":
      return {
        ...state,
        loading: false,
        coupon: action.payload,
        error: null,
      };
    case "VIEW_COUPON_FAILED":
      return {
        ...state,
        loading: false,
        coupon: null,
        error: action.payload,
      };

    // ================================
    // Builder List Actions
    // ================================
    case "GET_BUILDER_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        builderList: null,
        error: null,
      };
    case "GET_BUILDER_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        builderList: action.payload, // stores complete response (with .data array inside)
        error: null,
      };
    case "GET_BUILDER_LIST_FAILED":
      return {
        ...state,
        loading: false,
        builderList: null,
        error: action.payload,
      };

    // ================================
    // Category List Actions ✅ (NEW)
    // ================================
    case "GET_CATEGORY_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        categoryList: null,
        error: null,
      };
    case "GET_CATEGORY_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        categoryList: action.payload, // full response (with .data array)
        error: null,
      };
    case "GET_CATEGORY_LIST_FAILED":
      return {
        ...state,
        loading: false,
        categoryList: null,
        error: action.payload,
      };

    // ================================
    // Default
    // ================================
    default:
      return state;
  }
};
